namespace GeniuzPOS.Member {
    export interface MbReport_01_Dt_PluRow {
        Id?: string;
        ShopId?: string;
        ShopName?: string;
        DocDate?: string;
        DocNo?: string;
        MbId?: string;
        PluCode?: string;
        PluDesc?: string;
        Qty?: number;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
        DtList?: MbReport_01_Dt_Row[];
    }

    export namespace MbReport_01_Dt_PluRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'Member.MbReport_01_Dt_Plu';
        export const deletePermission = '3Member:สถานะสมาชิก:View';
        export const insertPermission = '3Member:สถานะสมาชิก:View';
        export const readPermission = '3Member:สถานะสมาชิก:View';
        export const updatePermission = '3Member:สถานะสมาชิก:View';

        export declare const enum Fields {
            Id = "Id",
            ShopId = "ShopId",
            ShopName = "ShopName",
            DocDate = "DocDate",
            DocNo = "DocNo",
            MbId = "MbId",
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            Qty = "Qty",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales",
            DtList = "DtList"
        }
    }
}
